// import $ from 'jquery'
// import Foundation from 'foundation-sites'
// alert('notifications loaded')

$(() => {
    $.get("/ajax-notifications/getNotifications", function(data) {
        if (!data) {
            $('.js-notification').addClass('hide')
            return false
        }
        $('.js-notifications-section').html(data)
        $('.js-notification-close').on('click', function() {
            window.scroll(0, 0)
            $(this).parents('.js-notification').addClass('hide')
            var nid = $(this).data('nid')
            if (!$(this).hasClass('hide')) {
                $.ajax({
                    type: 'POST',
                    url: "/ajax-notifications/dismiss",
                    data: {
                        id: nid
                    }
                })
            }
        })
        $('.js-notification').each(function() {
            var pageRegion = $('.js-notifications-section').data('cookie-page')
            var cookieRegion = $(this).data('cookie-page')
            if (cookieRegion == 'all') {
                $(this).removeClass('hide')
            } else if (cookieRegion == pageRegion) {
                $(this).removeClass('hide')
            }
        })
    })
})
$(window).on('load', function() {
    if ($('.js-sitepopup').length) {
        $('button.js-sitepopup-close').on('click', function(e) {
            $.post("/ajax-popup/dismiss", {
                id: $(this).data('nid')
            })
        })
        new Foundation.Reveal($('#site-modal'))
        $('.js-sitepopup').foundation('open')
    }
})
